<script setup lang="ts">
import DefaultLayout from "@/components/layouts/DefaultLayout.vue";
import { ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import UserArea from "../../components/ui/UserArea.vue";
import BroadcastMessageTabNav from "../../components/ui/BroadcastMessageTabNav.vue";
import { ClientError, getMessageFromError } from "@/libs/errors";
import { useRouter } from "vue-router";
import { useMutation } from "@vue/apollo-composable";
import { gql } from "@apollo/client/core";

const authStore = useAuthStore();
const sending = ref(false);
const errorMessage = ref("");
const router = useRouter();
const title = ref("");
const message = ref("");

const { mutate: sendingBroadcastMessage } = useMutation(
  gql`
    mutation Mutation($input: NewBroadcastMessageInput!) {
      createMessage(input: $input) {
        id
      }
    }
  `,
  {
    fetchPolicy: "no-cache",
  }
);

const sendMessage = async () => {
  if (sending.value) {
    return;
  }
  sending.value = true;
  try {
    if (title.value === "") {
      throw new ClientError("O título é obrigatório.");
    }
    await sendingBroadcastMessage({
      input: {
        title: title.value,
        body: message.value,
      },
    });
    alert("Mensagem enviada com sucesso!");
  } catch (err) {
    errorMessage.value = getMessageFromError(err);
  }
  router.push("/adm/broadcast-messages");
};
</script>

<template>
  <DefaultLayout>
    <article class="container framework-slot">
      <UserArea title="Mensagens de Disparo em Massa">
        <BroadcastMessageTabNav>
          <div class="row">
            <div class="col">
              <form @submit.prevent="sendMessage">
                <div class="form-group mb-3">
                  <label for="title" class="form-label">Título</label>
                  <div class="input-group">
                    <input
                      id="title"
                      type="text"
                      class="form-control"
                      v-model="title"
                      required
                    />
                  </div>
                </div>
                <div class="form-group mb-3">
                  <label for="message" class="form-label">Mensagem</label>
                  <textarea
                    class="form-control"
                    id="message"
                    v-model="message"
                    rows="3"
                  ></textarea>
                </div>
                <button
                  v-if="sending"
                  class="btn btn-primary mb-3 width-200px"
                  type="submit"
                  disabled
                >
                  Enviando...
                </button>
                <button
                  v-else
                  class="btn btn-primary mb-3 width-200px"
                  type="submit"
                >
                  Enviar para Todos
                </button>
              </form>
            </div>
          </div>
        </BroadcastMessageTabNav>
      </UserArea>
    </article>
  </DefaultLayout>
</template>

<style scoped>
textarea {
  resize: none;
}
</style>
